/**
 * Netherlands Antillean guilder.
 */
export var ANG = {
  code: 'ANG',
  base: 10,
  exponent: 2
};